"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.context_zdd = exports.context_menu_link = exports.context_menu_node = exports.menu_draggable = exports.OpenSankeyModalWelcome = exports.OpenSankeyMenus = exports.addAllDropDownFlux = exports.clickSaveSVG = void 0;
/* eslint @typescript-eslint/no-var-requires: "off" */
const d3 = __importStar(require("d3"));
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_bootstrap_1 = require("react-bootstrap");
const types_1 = require("./types");
const SankeyConvert_1 = require("./SankeyConvert");
const file_saver_1 = __importDefault(require("file-saver"));
const fa_1 = require("react-icons/fa");
const SankeyUtils = __importStar(require("./SankeyUtils"));
const SankeyLoad_1 = __importDefault(require("./SankeyLoad"));
const SankeyMenuConfiguration_1 = require("./SankeyMenuConfiguration");
// import ModalPreference from './SankeyMenuPreferences'
// import { ModalStyleLink, ModalStyleNode } from './SankeyMenuStyles'
const SankeyMenuDialogs_1 = require("./SankeyMenuDialogs");
const SankeyLayout_1 = require("./SankeyLayout");
const react_multi_select_component_1 = require("react-multi-select-component");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const SankeyMenuBanner_1 = require("./SankeyMenuBanner");
const SankeyLayout_2 = require("./SankeyLayout");
const SankeyMenuConfigurationLinks_1 = require("./SankeyMenuConfigurationLinks");
const SankeyLayout_3 = require("./SankeyLayout");
const react_draggable_1 = __importDefault(require("react-draggable"));
const CloseButton_1 = __importDefault(require("react-bootstrap/CloseButton"));
/**
 * Variable that define the Menu element, it's variable and function
 *
 * @type {{ data: any; set_data: any; right_menu: any; settings_edition: any; settings_edition_node_tags: any; settings_edition_link_tags: any; settings_edition_data_tags: any; ... 39 more ...; launch: any; }}
 */
const MenuPropTypes = {
    t: prop_types_1.default.func.isRequired,
    data: prop_types_1.default.shape(types_1.SankeyDataPropTypes).isRequired,
    set_data: prop_types_1.default.func.isRequired,
    default_sankey_data: prop_types_1.default.func.isRequired,
    logo: prop_types_1.default.string.isRequired,
    logo_terriflux: prop_types_1.default.string.isRequired,
    logo_width: prop_types_1.default.number,
    app_name: prop_types_1.default.string.isRequired,
    button_ref: prop_types_1.default.shape({ current: prop_types_1.default.instanceOf(HTMLLabelElement) }).isRequired,
    accordion_ref: prop_types_1.default.shape({ current: prop_types_1.default.instanceOf(HTMLDivElement) }).isRequired,
    selected_node: prop_types_1.default.shape({ current: prop_types_1.default.shape(types_1.SankeyNodePropTypes).isRequired }).isRequired,
    example_menu: prop_types_1.default.element,
    // portfolio_menu: PropTypes.element,
    formations_menu: prop_types_1.default.object.isRequired,
    url_prefix: prop_types_1.default.string.isRequired,
    nav_item_active: prop_types_1.default.string.isRequired,
    mode_selection: prop_types_1.default.shape({ current: prop_types_1.default.string.isRequired }).isRequired,
    style_to_apply: prop_types_1.default.string.isRequired,
    set_style_to_apply: prop_types_1.default.func.isRequired,
    callback: prop_types_1.default.func.isRequired,
    show_load: prop_types_1.default.bool.isRequired,
    set_show_load: prop_types_1.default.func.isRequired,
    processing: prop_types_1.default.bool.isRequired,
    setProcessing: prop_types_1.default.func.isRequired,
    failure: prop_types_1.default.bool.isRequired,
    setFailure: prop_types_1.default.func.isRequired,
    not_started: prop_types_1.default.bool.isRequired,
    setNotStarted: prop_types_1.default.func.isRequired,
    result: prop_types_1.default.string.isRequired,
    setResult: prop_types_1.default.func.isRequired,
    path: prop_types_1.default.string.isRequired,
    launch: prop_types_1.default.func.isRequired,
    configurations_menus: prop_types_1.default.arrayOf(prop_types_1.default.element.isRequired).isRequired,
    show_nav: prop_types_1.default.bool.isRequired,
    set_show_nav: prop_types_1.default.func.isRequired,
    show_excel_dialog: prop_types_1.default.bool.isRequired,
    set_show_excel_dialog: prop_types_1.default.func.isRequired,
    show_apply_layout: prop_types_1.default.bool.isRequired,
    set_show_apply_layout: prop_types_1.default.func.isRequired,
    show_save_json: prop_types_1.default.bool.isRequired,
    set_show_save_json: prop_types_1.default.func.isRequired,
    showPreference: prop_types_1.default.bool.isRequired,
    setShowPreference: prop_types_1.default.func.isRequired,
    show_publish_dialog: prop_types_1.default.bool.isRequired,
    set_show_publish_dialog: prop_types_1.default.func.isRequired,
    menus: prop_types_1.default.objectOf(prop_types_1.default.element.isRequired).isRequired,
    show_modalTemplate: prop_types_1.default.bool.isRequired,
    set_show_modalTemplate: prop_types_1.default.func.isRequired,
    cardsTemplate: prop_types_1.default.element.isRequired,
    external_modal: prop_types_1.default.arrayOf(prop_types_1.default.element.isRequired).isRequired,
    min_width_and_height: prop_types_1.default.func.isRequired,
    reinitialization: prop_types_1.default.func.isRequired,
    set_show_modale_tuto: prop_types_1.default.func.isRequired,
    show_modale_tuto: prop_types_1.default.bool.isRequired,
    show_modale_support: prop_types_1.default.bool.isRequired,
    set_show_modale_support: prop_types_1.default.func.isRequired,
    additional_nav_item: prop_types_1.default.arrayOf(prop_types_1.default.element.isRequired).isRequired,
    set_contextualised_node: prop_types_1.default.func.isRequired,
    set_contextualised_link: prop_types_1.default.func.isRequired,
    set_show_context_zdd: prop_types_1.default.func.isRequired,
    updateLayout: prop_types_1.default.func.isRequired,
    convert_data: prop_types_1.default.func.isRequired,
    node_hspace: prop_types_1.default.number.isRequired,
    set_node_hspace: prop_types_1.default.func.isRequired,
    node_vspace: prop_types_1.default.number.isRequired,
    set_node_vspace: prop_types_1.default.func.isRequired,
};
const pre_process_export_svg = () => {
    // Resize the svg scale to be the scale by default
    const svg = window.d3.select(' .opensankey#svg-container svg');
    svg.attr('transform', 'scale(1)');
    svg.select('#g_legend').style('transform', 'scale(1)');
    // Get size of g elements that contain visual content
    const g_nodes = document.getElementById('g_nodes');
    const size_nodes = (g_nodes) ? [(g_nodes.getBoundingClientRect().width + g_nodes.getBoundingClientRect().x), (g_nodes.getBoundingClientRect().height + g_nodes.getBoundingClientRect().y)] : [0, 0];
    const g_links = document.getElementById('g_links');
    const size_links = (g_links) ? [(g_links.getBoundingClientRect().width + g_links.getBoundingClientRect().x), (g_links.getBoundingClientRect().height + g_links.getBoundingClientRect().y)] : [0, 0];
    const g_label = document.getElementById('g_label');
    const size_label = (g_label) ? [(g_label.getBoundingClientRect().width + g_label.getBoundingClientRect().x), (g_label.getBoundingClientRect().height + g_label.getBoundingClientRect().y)] : [0, 0];
    // Search the element that go to the most bottom right of the sankey
    const export_dim_unscaled = [Math.max(size_nodes[0], size_links[0], size_label[0]), Math.max(size_nodes[1], size_links[1], size_label[1])];
    // Resize the svg width and height with the minimum value it require to display the elements
    svg.style('width', export_dim_unscaled[0] + 'px');
    svg.style('height', export_dim_unscaled[1] + 'px');
    // Hidde non-essential visual elements
    svg.selectAll('.sankey-tooltip').remove();
    svg.selectAll('text[visibility=hidden]').remove();
    svg.style('border', '0px');
    svg.style('background-color', '#fff');
    svg.select('#grid').style('opacity', '0');
    svg.selectAll('.box_width_threshold').remove();
    d3.selectAll('.gg_nodes rect').attr('stroke-width', 0);
    d3.selectAll(' .opensankey .gg_link_handles rect.handle').attr('fill-opacity', '0').attr('cursor', 'pointer');
    d3.selectAll(' .opensankey .gg_link_handles .drag_zone').attr('cursor', 'pointer').attr('stroke-opacity', '0');
    d3.selectAll(' .opensankey .gg_link_handles .center_handle').attr('stroke-opacity', '0').attr('fill-opacity', '0');
    d3.selectAll('.opensankey .gg_label rect').attr('stroke-width', '1');
    return svg;
};
const post_process_export_svg = () => {
    window.d3.select(' .opensankey#svg-container svg').style('background-color', 'inherit');
    window.d3.select(' .opensankey#svg-container svg').select('#grid').style('opacity', '1');
    window.d3.select(' .opensankey#svg-container svg').style('border', '2px');
};
const clickSaveSVG = () => {
    const svg = pre_process_export_svg();
    const html = svg.attr('title', 'test2')
        .attr('version', 1.1)
        .attr('xmlns', 'http://www.w3.org/2000/svg')
        .attr('xhtml', 'http://www.w3.org/1999/xhtml')
        .attr('xmlns:xlink', 'http://www.w3.org/1999/xlink')
        .attr('xmlns:xhtml', 'http://www.w3.org/1999/xhtml')
        .node().parentNode.innerHTML;
    const blob = new Blob([html], { type: 'image/svg+xml' });
    const form_data = new FormData();
    form_data.append('svg', blob);
    post_process_export_svg();
    const path = window.location.href;
    let url = path + '/opensankey/sankey/save_svg';
    const fetchData = {
        method: 'POST',
        body: form_data
    };
    const showFile = (blob) => {
        const newBlob = new Blob([blob], { type: 'application/svg' });
        file_saver_1.default.saveAs(newBlob, 'sankey_diagram.svg');
    };
    const cleanFile = () => {
        const fetchData = {
            method: 'POST'
        };
        url = path + '/opensankey/sankey/clean_svg';
        fetch(url, fetchData);
    };
    fetch(url, fetchData).then(r => r.blob())
        .then(showFile).then(cleanFile);
};
exports.clickSaveSVG = clickSaveSVG;
const clickSavePDF = (data) => {
    const svg = pre_process_export_svg();
    const html = svg.attr('title', 'test2')
        .attr('version', 1.1)
        .attr('xmlns', 'http://www.w3.org/2000/svg')
        .node().parentNode.innerHTML;
    const blob = new Blob([html], { type: 'image/svg+xml' });
    const form_data = new FormData();
    form_data.append('html', blob);
    form_data.append('width', data.width.toString());
    form_data.append('height', data.height.toString());
    post_process_export_svg();
    const path = window.location.href;
    let url = path + '/opensankey/sankey/save_pdf';
    const fetchData = {
        method: 'POST',
        body: form_data
    };
    const showFile = (blob) => {
        const newBlob = new Blob([blob], { type: 'application/pdf' });
        file_saver_1.default.saveAs(newBlob, 'sankey_diagram.pdf');
    };
    const cleanFile = () => {
        const fetchData = {
            method: 'POST'
        };
        url = path + '/opensankey/sankey/clean_pdf';
        fetch(url, fetchData);
    };
    fetch(url, fetchData).then(r => r.blob())
        .then(showFile).then(cleanFile);
};
const clickSavePNG = () => {
    const svg = pre_process_export_svg();
    const html = svg.attr('title', 'test2')
        .attr('version', 1.1)
        .attr('xmlns', 'http://www.w3.org/2000/svg')
        .node().parentNode.innerHTML;
    const blob = new Blob([html], { type: 'image/svg+xml' });
    const form_data = new FormData();
    form_data.append('html', blob);
    post_process_export_svg();
    const path = window.location.href;
    let url = path + '/opensankey/sankey/save_png';
    const fetchData = {
        method: 'POST',
        body: form_data
    };
    const showFile = (blob) => {
        const newBlob = new Blob([blob], { type: 'application/png' });
        file_saver_1.default.saveAs(newBlob, 'sankey_diagram.png');
    };
    const cleanFile = () => {
        const fetchData = {
            method: 'POST'
        };
        url = path + '/opensankey/sankey/clean_png';
        fetch(url, fetchData);
    };
    fetch(url, fetchData).then(r => r.blob())
        .then(showFile).then(cleanFile);
};
const goToUserDoc = () => {
    const path = window.location.href;
    const url = path + 'doc';
    fetch(url, {
        method: 'GET'
    }).then((response) => {
        if (response.redirected) {
            return window.open(response.url, '_blank');
        }
    }).then(win => win === null || win === void 0 ? void 0 : win.focus());
};
/**
 *
 *
 * @param {React.ChangeEvent<HTMLSelectElement>} evt
 * @param {TagsGroup} tags_group
 * @param {SankeyData} data
 * @param {(data: SankeyData) => void} set_data
 * @returns {(void) => void}
 */
const handleSimpleDropdown = (evt, tags_group, data, set_data) => {
    const val = evt.target.value;
    Object.entries(tags_group.tags).forEach(tag => tag[1].selected = val === tag[0]);
    set_data(Object.assign({}, data));
};
/**
 *
 *
 * @param {[{ label: string, value: string }]} selected
 * @param {TagsGroup} tags_group
 * @param {SankeyData} data
 * @param {(data: SankeyData) => void} set_data
 * @returns {(void) => void}
 */
const handleMultiDropdown = (selected, tags_group, data, set_data) => {
    const tab_sel = selected.map((d) => {
        return d.value;
    });
    Object.entries(tags_group.tags).forEach(tag => tag[1].selected = tab_sel.includes(tag[1].name));
    // Permet d'eviter de désélectionner tous les dataTags ce qui créerait une erreur
    if (tab_sel.length == 0 && Object.values(data.dataTags).map(dt => dt.group_name).includes(tags_group.group_name)) {
        Object.entries(tags_group.tags)[0][1].selected = true;
    }
    set_data(Object.assign({}, data));
};
/**
 * Function that generate dropdown for each groupTag of linkTags
 *
 * @param {TagsCatalog} fluxTags
 * @param {SankeyData} data
 * @param {(data: SankeyData) => void} set_data
 * @returns {(void) => any}
 */
const addAllDropDownFlux = (t, fluxTags, data, set_data) => {
    const banner_grouptag = Object.values(fluxTags).filter(tags_group => { return (tags_group.banner == 'one' || tags_group.banner == 'multi'); });
    const allDD = banner_grouptag.map(tags_group => {
        const the_tags_group = tags_group;
        const tags_selected = Object.entries(data['fluxTags']).filter((k) => { return k[1] == the_tags_group; })[0];
        if (the_tags_group.banner == 'one') {
            return (react_1.default.createElement(react_bootstrap_1.FormGroup, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Row, null,
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 },
                        react_1.default.createElement(react_bootstrap_1.FormLabel, null, the_tags_group.group_name))),
                react_1.default.createElement(react_bootstrap_1.Row, null,
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Banner.ndd_lst.1', placement: 'bottom', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Banner.ndd_lst.1' },
                            t('Banner.ndd_lst'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 }, react_1.default.createElement(react_bootstrap_1.Form.Select, { key: the_tags_group.group_name, placeholder: 'all', onChange: (evt) => {
                                handleSimpleDropdown(evt, the_tags_group, data, set_data);
                            } }, Object.entries(the_tags_group.tags).map(([tag_key, tag], i) => {
                            return (react_1.default.createElement("option", { key: i, value: tag_key }, tag.name));
                        })))),
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Banner.ndd_chk.1', placement: 'bottom', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Banner.ndd_chk.1' },
                                t('Banner.ndd_chk'),
                                " ") },
                            react_1.default.createElement(react_bootstrap_1.FormCheck, { inline: true, type: 'switch', checked: data.colorMap == tags_selected[0], onChange: evt => {
                                    Object.values(data.nodeTags).forEach(tags_group => tags_group.show_legend = false);
                                    Object.values(data.fluxTags).forEach(tags_group => tags_group.show_legend = false);
                                    Object.values(data.dataTags).forEach(tags_group => tags_group.show_legend = false);
                                    Object.values(data.nodes).forEach(el => {
                                        el.colorParameter = 'local';
                                        el.colorTag = 'no_colormap';
                                    });
                                    Object.values(data.links).forEach(el => {
                                        el.colorParameter = 'local';
                                        el.colorTag = 'no_colormap';
                                    });
                                    data.colorMap = 'no_colormap';
                                    if (evt.target.checked) {
                                        Object.values(data.nodes).forEach(el => {
                                            el.colorParameter = 'groupTag';
                                            el.colorTag = tags_selected[0];
                                        });
                                        Object.values(data.links).forEach(el => {
                                            el.colorParameter = 'groupTag';
                                            el.colorTag = tags_selected[0];
                                        });
                                        data.colorMap = tags_selected[0];
                                        data.fluxTags[tags_selected[0]].show_legend = true;
                                    }
                                    set_data(Object.assign({}, data));
                                } }))))));
        }
        else if (the_tags_group.banner == 'multi') {
            const options = Object.entries(the_tags_group.tags).map((tag) => { return { 'label': tag[1].name, 'value': tag[1].name }; });
            const selected = Object.entries(the_tags_group.tags).filter(d => d[1].selected).map((tag) => { return { 'label': tag[1].name, 'value': tag[1].name }; });
            return (react_1.default.createElement(react_bootstrap_1.FormGroup, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Row, null,
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 },
                        react_1.default.createElement(react_bootstrap_1.FormLabel, null, the_tags_group.group_name))),
                react_1.default.createElement(react_bootstrap_1.Row, null,
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Banner.ndd_lst.2', placement: 'bottom', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Banner.ndd_lst.2' },
                            t('Banner.ndd_lst'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 },
                            react_1.default.createElement(react_multi_select_component_1.MultiSelect, { className: 'multidropdown_filter_node_link', style: { color: 'black', width: '200px' }, valueRenderer: (selected) => {
                                    return selected.length ? selected.map(({ label }) => label + ', ') : 'Aucun tag sélectionné';
                                }, labelledBy: 'dropdown_node_filter', overrideStrings: {
                                    'selectAll': 'Tout sélectionner',
                                }, value: selected, options: options, onChange: (selected) => {
                                    handleMultiDropdown(selected, the_tags_group, data, set_data);
                                } }))),
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Banner.ndd_chk.2', placement: 'bottom', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Banner.ndd_chk.2' },
                                t('Banner.ndd_chk'),
                                " ") },
                            react_1.default.createElement(react_bootstrap_1.FormCheck, { inline: true, type: 'switch', checked: data.colorMap == tags_selected[0], onChange: evt => {
                                    Object.values(data.nodeTags).forEach(tags_group => tags_group.show_legend = false);
                                    Object.values(data.fluxTags).forEach(tags_group => tags_group.show_legend = false);
                                    Object.values(data.dataTags).forEach(tags_group => tags_group.show_legend = false);
                                    Object.values(data.nodes).forEach(el => {
                                        el.colorParameter = 'local';
                                        el.colorTag = 'no_colormap';
                                    });
                                    Object.values(data.links).forEach(el => {
                                        el.colorParameter = 'local';
                                        el.colorTag = 'no_colormap';
                                    });
                                    data.colorMap = 'no_colormap';
                                    if (evt.target.checked) {
                                        Object.values(data.nodes).forEach(el => {
                                            el.colorParameter = 'groupTag';
                                            el.colorTag = tags_selected[0];
                                        });
                                        Object.values(data['links']).forEach(el => {
                                            el.colorParameter = 'groupTag';
                                            el.colorTag = tags_selected[0];
                                        });
                                        data.colorMap = tags_selected[0];
                                        data['fluxTags'][tags_selected[0]].show_legend = true;
                                    }
                                    set_data(Object.assign({}, data));
                                } }))))));
        }
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("tr", null,
            react_1.default.createElement("th", null, t('Banner.ndd_lst')),
            react_1.default.createElement("th", null, t('Banner.ndd_chk'))),
        allDD.map((c, i) => { return react_1.default.createElement(react_1.default.Fragment, { key: i }, c); })));
};
exports.addAllDropDownFlux = addAllDropDownFlux;
const OpenSankeyMenus = (t, setShowPreference, reinitialization, default_sankey_data, set_show_apply_layout, set_show_excel_dialog, set_show_save_json, showStyleEdition, showStyleEditionLink, set_show_welcome, set_never_see_again, data, set_data, set_show_modalTemplate, set_show_modale_support, external_edition_item, externale_save_item, set_tags_selected, convert_data) => {
    const _load_json = react_1.useRef(null);
    const node_filter = Object.entries(data.nodeTags).filter(([, v]) => v.banner !== 'none' && v.banner !== 'level').length > 0;
    const flux_filter = Object.entries(data.fluxTags).filter(([, v]) => v.banner !== 'none').length > 0;
    const opacity_advanced = !window.SankeyToolsStatic ? '0.3' : '0';
    const DT_length = Object.keys(data.dataTags).length;
    // Recursive function to create multiple copy of a link,according to the number of dataTags selected, to display the different value of a same link
    const recursionDataTag = (DT, ind, suffix, link_to_copy, new_links) => {
        const DT_l = Object.values(DT).length;
        Object.values(Object.values(DT)[ind].tags)
            .filter(t => t.selected).forEach((d, i) => {
            const n_suffix = suffix + '_' + i;
            // Depth search of group_dataTag, if it the deepest, a link is created with a specific id to retrieve the right value of the link in getLinkValue
            // (Deepest= last group_dataTag )
            if (ind == DT_l - 1) {
                const n_l = JSON.parse(JSON.stringify(link_to_copy));
                n_l.idLink = n_l.idLink + n_suffix;
                new_links[n_l.idLink] = n_l;
                //Ajoute dans les noeuds source/target les id de flux
                const ind_in_src = data.nodes[link_to_copy.idSource].outputLinksId.indexOf(link_to_copy.idLink);
                if (ind_in_src >= 0) {
                    data.nodes[link_to_copy.idSource].outputLinksId.splice(ind_in_src, 1);
                }
                const ind_in_trgt = data.nodes[link_to_copy.idTarget].inputLinksId.indexOf(link_to_copy.idLink);
                if (ind_in_trgt >= 0) {
                    data.nodes[link_to_copy.idTarget].inputLinksId.splice(ind_in_trgt, 1);
                }
                data.nodes[link_to_copy.idSource].outputLinksId.push(n_l.idLink);
                data.nodes[link_to_copy.idTarget].inputLinksId.push(n_l.idLink);
            }
            else {
                recursionDataTag(DT, ind + 1, n_suffix, link_to_copy, new_links);
            }
        });
    };
    // Function that return a simple or multiple dropdown of groupTag of data and links
    // This allow us to choose wich grouptag to select and wich tag of these group to display
    const addAllDropDownLinks = () => {
        const banner_grouptag = Object.entries(data.dataTags).filter(([, tags_group]) => { return (tags_group.banner == 'one' || tags_group.banner == 'multi'); });
        const allDD = banner_grouptag.map(([, tags_group]) => {
            if (tags_group.banner == 'one') {
                let selected = '';
                if (Object.entries(tags_group.tags).filter(([, v]) => v.selected).length > 0) {
                    selected = Object.entries(tags_group.tags).filter(([, v]) => v.selected)[0][0];
                }
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, tags_group.group_name),
                    react_1.default.createElement(react_bootstrap_1.FormGroup, { as: react_bootstrap_1.Row },
                        react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 }, react_1.default.createElement(react_bootstrap_1.Form.Select, { key: tags_group.group_name, placeholder: 'all', value: selected, onChange: (evt) => {
                                const pl = Object.entries(data.links).map(l => {
                                    const suffixeStart = l[0].indexOf('_');
                                    if (suffixeStart >= 0) {
                                        l[0] = l[0].slice(0, suffixeStart);
                                        l[1].idLink = l[0];
                                        data.nodes[l[1].idSource].outputLinksId = data.nodes[l[1].idSource].outputLinksId.filter(nl => nl.indexOf('_') == -1);
                                        data.nodes[l[1].idTarget].inputLinksId = data.nodes[l[1].idTarget].inputLinksId.filter(nl => nl.indexOf('_') == -1);
                                        //Ajoute dans les noeuds source/target les id de flux
                                        const ind_in_src = data.nodes[l[1].idSource].outputLinksId.indexOf(l[1].idLink);
                                        if (ind_in_src == -1) {
                                            data.nodes[l[1].idSource].outputLinksId.push(l[0]);
                                        }
                                        const ind_in_trgt = data.nodes[l[1].idTarget].inputLinksId.indexOf(l[1].idLink);
                                        if (ind_in_trgt == -1) {
                                            data.nodes[l[1].idTarget].inputLinksId.push(l[0]);
                                        }
                                    }
                                    return l;
                                });
                                // Reforme les flux originel (sans suffixe) et supprime les doublons par la méme occasions
                                const pureLinks = Object.fromEntries(pl);
                                data.links = pureLinks;
                                handleSimpleDropdown(evt, tags_group, data, set_data);
                                const newEntries = new Map(Object.entries(data.dataTags).map(([dataTagKey, dataTag]) => {
                                    return (Object.keys(dataTag.tags).length > 0) ? [
                                        dataTagKey,
                                        Object.entries(dataTag.tags).filter(tag => tag[1].selected).length > 0 ? Object.entries(dataTag.tags).filter(tag => tag[1].selected)[0][0] : Object.keys(dataTag.tags)[0]
                                    ] : ['n', 'n'];
                                }));
                                const dataTagsSelected = Object.fromEntries(newEntries);
                                set_tags_selected(dataTagsSelected);
                            } }, Object.entries(tags_group.tags).map(([tag_key, tag], i) => {
                            return (react_1.default.createElement("option", { key: i, value: tag_key }, tag.name));
                        }))))));
            }
            else if (tags_group.banner == 'multi') {
                const selected = Object.entries(tags_group.tags).filter(d => d[1].selected).map((tag) => { return { 'label': tag[1].name, 'value': tag[1].name }; });
                const options = Object.entries(tags_group.tags).map((tag) => { return { 'label': tag[1].name, 'value': tag[1].name, 'disabled': ((selected.length < 2 && tag[1].name == selected[0].label)) }; });
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_bootstrap_1.FormLabel, null, tags_group.group_name),
                    react_1.default.createElement(react_multi_select_component_1.MultiSelect, { className: 'multidropdown_filter_node_link', style: { color: 'black', width: '200px' }, labelledBy: 'dropdown_link_filter', overrideStrings: {
                            'selectAll': 'Tout sélectionner',
                        }, value: selected, options: options, onChange: (selected) => {
                            handleMultiDropdown(selected, tags_group, data, set_data);
                            //Multiplie les flux par le nombre de dataTags Sélectionné ( et si le lien à une valeur pour ce dataTags)
                            if (Object.keys(data.dataTags).length > 0) {
                                const pl = Object.entries(data.links).map(l => {
                                    const suffixeStart = l[0].indexOf('_');
                                    if (suffixeStart >= 0) {
                                        l[0] = l[0].slice(0, suffixeStart);
                                        l[1].idLink = l[0];
                                        data.nodes[l[1].idSource].outputLinksId = data.nodes[l[1].idSource].outputLinksId.filter(nl => nl.indexOf('_') == -1);
                                        data.nodes[l[1].idTarget].inputLinksId = data.nodes[l[1].idTarget].inputLinksId.filter(nl => nl.indexOf('_') == -1);
                                    }
                                    return l;
                                });
                                // Reforme les flux originel (sans suffixe) et supprime les doublons par la méme occasions
                                const pureLinks = Object.fromEntries(pl);
                                const new_links = {};
                                Object.values(pureLinks).forEach(l => {
                                    const suffix = '';
                                    recursionDataTag(data.dataTags, 0, suffix, l, new_links);
                                });
                                data.links = new_links;
                                set_data(Object.assign({}, data));
                            }
                        } })));
            }
        });
        return allDD;
    };
    //Popover element to handle node tags
    // Its a list of dropdown for each groupNodeTag where we can choose wiche group to apply and wiche tag from these group to display when selected
    const filter_color_node = react_1.default.createElement(react_bootstrap_1.Popover, { id: 'tooltip-link-color-filter', style: { maxWidth: '100%' } },
        react_1.default.createElement(react_bootstrap_1.Popover.Header, { as: "h3" }, t('Banner.fdn')),
        react_1.default.createElement(react_bootstrap_1.Popover.Body, { style: { marginLeft: '5px', width: '450px' } },
            react_1.default.createElement(react_1.default.Fragment, null, (Object.entries(data.nodeTags).filter(([, v]) => v.banner !== 'none').length > 0) ? (react_1.default.createElement(react_1.default.Fragment, null, SankeyMenuBanner_1.addAllDropDownNode(t, data, set_data, false))) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_bootstrap_1.Form.Control, { placeholder: "Pas de filtrage", style: { opacity: opacity_advanced, color: '#6c757d' }, disabled: true }))))));
    //Popover element to handle the display of link tags
    const filter_color_link = react_1.default.createElement(react_bootstrap_1.Popover, { id: 'tooltip-node-color-filter', style: { maxWidth: '100%' } },
        react_1.default.createElement(react_bootstrap_1.Popover.Header, { as: "h3" }, t('Banner.fdf')),
        react_1.default.createElement(react_bootstrap_1.Popover.Body, { style: { marginLeft: '5px', width: '450px' } }, exports.addAllDropDownFlux(t, data.fluxTags, data, set_data)));
    //Popover element to handle the display of data tags
    const filter_data = react_1.default.createElement(react_bootstrap_1.Popover, { id: 'tooltip-data-color-filter', style: { maxWidth: '100%' } },
        react_1.default.createElement(react_bootstrap_1.Popover.Header, { as: "h3" }, t('Banner.sdd')),
        react_1.default.createElement(react_bootstrap_1.Popover.Body, null,
            react_1.default.createElement(react_bootstrap_1.FormGroup, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 }, addAllDropDownLinks()),
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                    react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'switch', style: { marginLeft: '-2em' }, checked: (DT_length > 0) ? (Object.values(data.dataTags).slice(DT_length - 1, DT_length)[0].show_legend) : false, onChange: evt => {
                            //Déselecitonne tous les type de tag
                            Object.values(data.nodeTags).forEach(tags_group => tags_group.show_legend = false);
                            Object.values(data.fluxTags).forEach(tags_group => tags_group.show_legend = false);
                            Object.values(data.dataTags).forEach(tags_group => tags_group.show_legend = false);
                            Object.values(data.nodes).forEach(el => {
                                el.colorParameter = 'local';
                                el.colorTag = 'no_colormap';
                            });
                            Object.values(data.links).forEach(el => {
                                el.colorParameter = 'local';
                                el.colorTag = 'no_colormap';
                            });
                            data.colorMap = 'no_colormap';
                            //Met le dernier dataTag en tant que couleur a suivre pour les flux
                            if (evt.target.checked) {
                                Object.values(data.nodes).forEach(el => {
                                    el.colorParameter = 'groupTag';
                                    el.colorTag = 'no_colormap';
                                });
                                Object.values(data.links).forEach(el => {
                                    el.colorParameter = 'groupTag';
                                    el.colorTag = 'no_colormap';
                                });
                                data.colorMap = 'dataTags_' + Object.keys(data.dataTags).slice(DT_length - 1, DT_length)[0];
                                Object.values(data.dataTags).slice(DT_length - 1, DT_length)[0].show_legend = evt.target.checked;
                            }
                            set_data(Object.assign({}, data));
                        } })))));
    const item_dropdown_filter = react_1.default.createElement(react_1.default.Fragment, null,
        (node_filter) ?
            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tooltip-link-color-filter', placement: 'bottom', trigger: 'click', rootClose: true, overlay: filter_color_node },
                react_1.default.createElement(react_bootstrap_1.Button, { size: 'sm', variant: 'light' }, t('Menu.Noeuds')))
            :
                react_1.default.createElement(react_1.default.Fragment, null),
        (flux_filter) ?
            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tooltip-node-color-filter', placement: 'bottom', trigger: 'click', rootClose: true, overlay: filter_color_link },
                react_1.default.createElement(react_bootstrap_1.Button, { size: 'sm', variant: 'light' }, t('Menu.flux')))
            :
                react_1.default.createElement(react_1.default.Fragment, null),
        (Object.values(data.dataTags).length > 0) ?
            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tooltip-data-filter', placement: 'bottom', trigger: 'click', rootClose: true, overlay: filter_data },
                react_1.default.createElement(react_bootstrap_1.Button, { size: 'sm', variant: 'light' },
                    react_1.default.createElement(react_1.default.Fragment, null, t('Banner.data'))))
            :
                react_1.default.createElement(react_1.default.Fragment, null));
    const logo_tempalte = react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", "aria-hidden": 'false', "data-prefix": 'fas', className: 'svg-inline--fa', viewBox: "0 0 24 24" },
        react_1.default.createElement("path", { fill: 'currentColor', d: "M10,7.5c0-.83,.67-1.5,1.5-1.5s1.5,.67,1.5,1.5-.67,1.5-1.5,1.5-1.5-.67-1.5-1.5Zm14-1v5c0,3.03-2.47,5.5-5.5,5.5H10.5c-3.03,0-5.5-2.47-5.5-5.5V6.5c0-3.03,2.47-5.5,5.5-5.5h8c3.03,0,5.5,2.47,5.5,5.5ZM8,11.5c0,1,.59,1.86,1.43,2.26l4.28-4.28c.62-.62,1.64-.62,2.26,0l1.04,1.04c.62,.62,1.64,.62,2.26,0l1.72-1.72v-2.29c0-1.38-1.12-2.5-2.5-2.5H10.5c-1.38,0-2.5,1.12-2.5,2.5v5Zm8.5,7.5H5.5c-1.38,0-2.5-1.12-2.5-2.5v-7c0-.83-.67-1.5-1.5-1.5s-1.5,.67-1.5,1.5v7c0,3.03,2.47,5.5,5.5,5.5h11c.83,0,1.5-.67,1.5-1.5s-.67-1.5-1.5-1.5Z" }));
    // OBJECT THAT CONTAIN DIFFERENT MENUS
    const ui = {};
    if (!window.SankeyToolsStatic) {
        ui['file'] = react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_bootstrap_1.Dropdown, { className: 'buttonSubNav', drop: 'end', id: 'ouvrir' },
                react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { size: 'sm', variant: 'light' },
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faFolderOpen })),
                        react_1.default.createElement(react_bootstrap_1.Col, { className: 'textIcon' }, t('Menu.ouvrir')))),
                react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, null,
                    react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => {
                            if (_load_json.current) {
                                _load_json.current.name = '';
                                _load_json.current.click();
                            }
                        } }, "JSON"),
                    react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "file", ref: _load_json, style: { display: 'none' }, onChange: (evt) => {
                            const files = evt.target.files;
                            const reader = new FileReader();
                            reader.onload = (() => {
                                return (e) => {
                                    reinitialization();
                                    const result = String(e.target.result);
                                    const new_data = default_sankey_data();
                                    const result_data = JSON.parse(result);
                                    Object.assign(new_data, result_data);
                                    if (result_data.version === undefined) {
                                        new_data.version = undefined;
                                    }
                                    convert_data(new_data);
                                    SankeyConvert_1.complete_sankey_data(new_data, default_sankey_data, SankeyUtils.default_node, SankeyUtils.default_link);
                                    // SankeyUtils.set_nodes_level(data)
                                    console.log('open json');
                                    set_data(new_data);
                                    const test = document.getElementsByClassName('navbar');
                                    let margin_top = 0;
                                    if (test && test.length > 0) {
                                        margin_top = test[0].getBoundingClientRect().height;
                                        d3.select(' .opensankey #svg-container').style('margin-top', margin_top + 'px');
                                    }
                                };
                            })();
                            reader.readAsText(files[0]);
                        } }),
                    react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => set_show_excel_dialog(true) }, "Excel"))),
            react_1.default.createElement(react_bootstrap_1.Dropdown, { className: 'buttonSubNav', drop: 'end', id: 'enregistrer' },
                react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { size: 'sm', variant: 'light' },
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faDownload })),
                        react_1.default.createElement(react_bootstrap_1.Col, { className: 'textIcon' }, t('Menu.enregistrer')))),
                react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, null,
                    react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => {
                            set_show_save_json(true);
                        } }, "JSON"),
                    react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => SankeyUtils.clickSaveExcel('/opensankey/', data) }, "Excel"),
                    externale_save_item)),
            react_1.default.createElement(react_bootstrap_1.Dropdown, { className: 'buttonSubNav', drop: 'end', id: 'exporter' },
                react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { size: 'sm', variant: 'light' },
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faFileExport })),
                        react_1.default.createElement(react_bootstrap_1.Col, { className: 'textIcon' }, t('Menu.exporter')))),
                react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, null,
                    react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: exports.clickSaveSVG },
                        t('Menu.exporter'),
                        " SVG"),
                    react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => clickSavePDF(data) },
                        t('Menu.exporter'),
                        " PDF"),
                    react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => clickSavePNG() },
                        t('Menu.exporter'),
                        " PNG"))),
            react_1.default.createElement(react_bootstrap_1.Button, { size: 'sm', variant: 'light', onClick: () => { setShowPreference(true); } }, react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_bootstrap_1.Col, null,
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faGears })),
                react_1.default.createElement(react_bootstrap_1.Col, { className: 'textIcon' }, t('Menu.preference')))),
            react_1.default.createElement(react_bootstrap_1.Button, { size: 'sm', variant: 'light', onClick: () => { set_show_modalTemplate(true); } }, react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_bootstrap_1.Col, null, logo_tempalte),
                react_1.default.createElement(react_bootstrap_1.Col, { className: 'textIcon' }, t('Menu.templates')))),
            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'buttonCheckpoint', placement: 'left', delay: 500, overlay: (react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'buttonCheckpoint' },
                    t('Menu.tooltips.checkpoint'),
                    " ")) },
                react_1.default.createElement(react_bootstrap_1.Button, { size: 'sm', variant: 'light', onClick: () => {
                        const ev = document;
                        const tmp = new KeyboardEvent('keydown', { key: 's', ctrlKey: true });
                        if (ev.onkeydown) {
                            ev.onkeydown(tmp);
                        }
                    } },
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faFloppyDisk })),
                        react_1.default.createElement(react_bootstrap_1.Col, { className: 'textIcon' }, t('Menu.check'))))));
        ui['edition'] = react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_bootstrap_1.Button, { size: 'sm', variant: 'light', onClick: reinitialization },
                react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faTrashCan })),
                    react_1.default.createElement(react_bootstrap_1.Col, { className: 'textIcon' }, t('Menu.reinit')))),
            react_1.default.createElement(react_bootstrap_1.Button, { size: 'sm', variant: 'light', onClick: () => set_show_apply_layout(true) },
                react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faFileInvoice })),
                    react_1.default.createElement(react_bootstrap_1.Col, { className: 'textIcon' }, t('Menu.amp_short')))),
            react_1.default.createElement(react_bootstrap_1.Dropdown, { className: 'buttonSubNav', drop: 'end', id: 'exporter' },
                react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { size: 'sm', variant: 'light' },
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faPenToSquare })),
                        react_1.default.createElement(react_bootstrap_1.Col, { className: 'textIcon' }, t('Menu.style')))),
                react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, null,
                    react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { size: 'sm', variant: 'light', onClick: showStyleEdition }, t('Menu.esn')),
                    react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { size: 'sm', variant: 'light', onClick: showStyleEditionLink }, t('Menu.esf')))),
            external_edition_item);
        ui['aide'] = react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_bootstrap_1.Button, { size: 'sm', variant: 'light', onClick: () => {
                    set_show_welcome(true);
                    set_never_see_again(false);
                    localStorage.setItem('dontSeeAggainWelcome', '0');
                } }, t('DisplayWelcome')),
            react_1.default.createElement(react_bootstrap_1.Button, { size: 'sm', variant: 'light', onClick: () => goToUserDoc() }, t('Menu.doc')),
            react_1.default.createElement(react_bootstrap_1.Button, { size: 'sm', variant: 'light', onClick: () => set_show_modale_support(true) }, t('Menu.support')));
    }
    if (node_filter || flux_filter || (Object.values(data.dataTags).length > 0)) {
        ui['filter'] =
            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tooltip-filter', placement: 'right', rootClose: true, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tooltip-filter' },
                    t('Banner.hlp_1_txt_9'),
                    " ") }, item_dropdown_filter);
    }
    return ui;
};
exports.OpenSankeyMenus = OpenSankeyMenus;
/**
 * Description placeholder
 *
 * @param {{ data: any; set_data: any;right_menu: any; settings_edition: any; settings_edition_node_tags: any; settings_edition_link_tags: any; settings_edition_data_tags: any; ... 39 more ...; launch: any; }}
 *
 * @returns
 */
const Menu = ({ t, data, set_data, default_sankey_data, nav_item_active, show_nav, set_show_nav, logo, logo_terriflux, logo_width, app_name, button_ref, accordion_ref, selected_node, url_prefix, callback, show_load, set_show_load, processing, setProcessing, failure, setFailure, not_started, setNotStarted, result, setResult, path, launch, configurations_menus, show_excel_dialog, set_show_excel_dialog, show_apply_layout, set_show_apply_layout, show_save_json, set_show_save_json, menus, show_modalTemplate, set_show_modalTemplate, cardsTemplate, external_modal, min_width_and_height, formations_menu, reinitialization, set_show_modale_tuto, show_modale_tuto, show_modale_support, set_show_modale_support, additional_nav_item, set_contextualised_node, set_contextualised_link, set_show_context_zdd, updateLayout, convert_data, node_hspace, set_node_hspace, node_vspace, set_node_vspace }) => {
    var _a, _b;
    const [menu_acivated, set_menu_activated] = react_1.useState(Object.keys(menus)[0]);
    const [modale_sub_tuto, set_modale_sub_tuto] = react_1.useState(Object.keys(formations_menu)[0] !== undefined ? Object.keys(formations_menu)[0] : '');
    let max_link_value = 0;
    Object.values(data.links).forEach(link => {
        const new_max_link_value = SankeyUtils.findMaxLinkValue(max_link_value, link.value);
        max_link_value = new_max_link_value > max_link_value ? new_max_link_value : max_link_value;
    });
    max_link_value += 1;
    if (not_started == false && processing == false) {
        const path = window.location.href;
        const url = path + url_prefix + 'loads_retrieves_result';
        const form_data = new FormData();
        const fetchData = {
            method: 'POST',
            body: form_data
        };
        fetch(url, fetchData).then(response => {
            response.text().then(text => {
                try {
                    const server_data = JSON.parse(text);
                    if (data.layout) {
                        server_data.layout = data.layout;
                    }
                    const new_data = Object.assign(default_sankey_data(), SankeyUtils.processExample(server_data, updateLayout, convert_data));
                    callback(new_data);
                    delete new_data.layout;
                    set_data(Object.assign({}, new_data));
                    //set_show_load(false)
                }
                catch (err) {
                    alert(err);
                }
            });
        });
        setProcessing(false);
        setFailure(false);
        setNotStarted(true);
    }
    //Switch the variable value that handle opening and closing the configuration menu
    const toggleShow = () => {
        set_show_nav(!show_nav);
        if (!show_nav) {
            [data.width, data.height] = min_width_and_height(data);
            const transform = d3.select('.opensankey #svg').attr('transform').split('scale(');
            let scale_svg = 1;
            if (transform !== undefined) {
                scale_svg = Number(transform[1].replace(')', ''));
            }
            d3.select('.scroll_zone').style('width', ((data.width + 600) * scale_svg - (600 * (scale_svg - 1.1))) + 'px');
        }
        else {
            d3.select('.scroll_zone').style('width', null);
        }
    };
    const setChecked = react_1.useState(false)[1];
    let node = data.nodes[selected_node.current.idNode];
    if (node === undefined) {
        node = SankeyUtils.default_node(data);
    }
    const props = {
        scroll: true,
        backdrop: false,
    };
    const menuButton = () => {
        if (show_nav) {
            return react_1.default.createElement(fa_1.FaAngleDoubleRight, null);
        }
        else {
            return react_1.default.createElement(fa_1.FaAngleDoubleLeft, null);
        }
    };
    const has_scrollbar_shift = window.innerWidth - document.getElementsByTagName('html')[0].clientWidth;
    const ordered_menu = {};
    const oredred_key = ['file', 'edition', 'diagramme', 'excel', 'filter', 'view', 'afm', 'formation', 'demo', 'aide'];
    oredred_key.forEach((k) => {
        if (Object.keys(menus).includes(k)) {
            ordered_menu[k] = menus[k];
        }
    });
    // Pré-traitement du menu tuto pour trier les groupes
    const n_a = new Array(50);
    Object.keys(formations_menu).map(d => {
        return d.replace('_', '__').split('__');
    }).forEach(element => {
        if (element.length > 1) {
            n_a[Number(element[0])] = element[0] + '_' + element[1];
        }
        else {
            n_a[n_a.length - 1] = element[0];
        }
    });
    // Return l'objet formations_menu mais trier selon le numéro du groupe (quand il y en a un)
    const new_array_for_exemple = Object.fromEntries(n_a.filter(f => f).map((d) => {
        return [d, formations_menu[d]];
    }));
    let modal_tuto = react_1.default.createElement(react_1.default.Fragment, null);
    const tuto_sub_nav = {};
    Object.entries(new_array_for_exemple).forEach(d => {
        tuto_sub_nav[d[0]] = react_1.default.createElement(react_1.default.Fragment, null, d[1]['Files'].filter((f) => !f.includes('.xlsx')).map((dd) => {
            return react_1.default.createElement(react_bootstrap_1.Card, null,
                react_1.default.createElement(react_bootstrap_1.Card.Img, { className: 'img-card', variant: "top", src: '/fm/userfiles/Formations/' + (d[0]) + '/images/' + (dd.replace('_layout.json', '')) + '.png', style: { 'objectFit': 'contain' /*,'minHeight':'350px','maxHeight':'500px'*/ } }),
                react_1.default.createElement(react_bootstrap_1.Card.Body, null,
                    react_1.default.createElement(react_bootstrap_1.Card.Title, null, dd.replace('_layout.json', '').replaceAll('_', ' ')),
                    react_1.default.createElement(react_bootstrap_1.Card.Text, null),
                    react_1.default.createElement(react_bootstrap_1.ButtonGroup, null,
                        react_1.default.createElement(react_bootstrap_1.Button, { variant: 'primary', onClick: () => {
                                SankeyUtils.uploadExemple(('Formations/' + (d[0]) + '/sankey/' + dd), url_prefix, data, set_data, reinitialization, convert_data);
                                set_data(Object.assign({}, data));
                                set_show_modale_tuto(false);
                            } }, t('useTutoJSON')),
                        d[1]['Files'].includes(dd.replace('_layout.json', '.xlsx')) ?
                            react_1.default.createElement(react_bootstrap_1.Button, { variant: 'info', onClick: () => {
                                    launch('Formations/' + (d[0]) + '/' + dd.replace('_layout.json', '.xlsx'));
                                    SankeyUtils.uploadExemple('Formations/' + (d[0]) + '/' + dd.replace('_layout.json', '.xlsx'), url_prefix, data, set_data, reinitialization, convert_data);
                                    set_show_modale_tuto(false);
                                } }, t('useTutoExcel'))
                            : react_1.default.createElement(react_1.default.Fragment, null),
                        d[1]['Files'].includes(dd.replace('_layout.json', '_reconciled.xlsx')) ?
                            react_1.default.createElement(react_bootstrap_1.Button, { variant: 'info', onClick: () => {
                                    launch('Formations/' + (d[0]) + '/' + dd.replace('_layout.json', '_reconciled.xlsx'));
                                    SankeyUtils.uploadExemple('Formations/' + (d[0]) + '/' + dd.replace('_layout.json', '_reconciled.xlsx'), url_prefix, data, set_data, reinitialization, convert_data);
                                    set_show_modale_tuto(false);
                                } }, t('useTutoExcel'))
                            : react_1.default.createElement(react_1.default.Fragment, null))));
        }));
    });
    modal_tuto = react_1.default.createElement(react_bootstrap_1.Modal, { size: 'xl', fullscreen: true, show: show_modale_tuto, onHide: () => set_show_modale_tuto(false) },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true }, t('Menu.formation')),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
            react_1.default.createElement(react_bootstrap_1.Row, null,
                react_1.default.createElement(react_bootstrap_1.Nav, { variant: "tabs", className: 'sub_nav', activeKey: modale_sub_tuto }, Object.keys(tuto_sub_nav).map(m => {
                    return react_1.default.createElement(react_bootstrap_1.Nav.Item, null,
                        react_1.default.createElement(react_bootstrap_1.Nav.Link, { eventKey: m, onClick: () => set_modale_sub_tuto(m) }, (m.split('_').length > 1) ? m.split('_').filter(s => isNaN(+s)).join(' ') : m));
                }))),
            react_1.default.createElement(react_bootstrap_1.Row, { md: 4 }, tuto_sub_nav[modale_sub_tuto])));
    // Create the menu nav that can be slightly different if it in static
    const menu_nav = (!window.SankeyToolsStatic) ? (react_1.default.createElement(react_bootstrap_1.Col, null,
        react_1.default.createElement(react_bootstrap_1.Row, null,
            react_1.default.createElement(react_bootstrap_1.Nav, { variant: "tabs", className: 'sub_nav', activeKey: menu_acivated }, Object.keys(ordered_menu).map(m => {
                if (m == 'formation') {
                    // Special behavior for formation nav, instead of opening a subnav it open a modal with the tutos
                    return react_1.default.createElement(react_bootstrap_1.Nav.Item, null,
                        react_1.default.createElement(react_bootstrap_1.Nav.Link, { eventKey: m, onClick: () => set_show_modale_tuto(true) }, t('Menu.' + m)));
                }
                else {
                    // Nav item that aopen a subnav when clicked
                    return react_1.default.createElement(react_bootstrap_1.Nav.Item, null,
                        react_1.default.createElement(react_bootstrap_1.Nav.Link, { eventKey: m, onClick: () => set_menu_activated(m) }, t('Menu.' + m)));
                }
            }))),
        react_1.default.createElement(react_bootstrap_1.Row, { lg: 'auto', style: { whiteSpace: 'nowrap' } },
            react_1.default.createElement(react_bootstrap_1.ButtonGroup, { className: 'subMenu ' + menu_acivated }, ordered_menu[menu_acivated])))) : react_1.default.createElement(react_bootstrap_1.ButtonGroup, null,
        " ",
        Object.keys(ordered_menu).map(k => react_1.default.createElement(react_1.default.Fragment, { key: k }, ordered_menu[k])));
    const modal_support = react_1.default.createElement(react_bootstrap_1.Modal, { size: 'lg', show: show_modale_support, onHide: () => set_show_modale_support(false) },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement("h2", null, t('Menu.c_support'))),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
            react_1.default.createElement("h3", null,
                t('Menu.rth_support'),
                " :"),
            react_1.default.createElement("p", null,
                t('Menu.support_explication').split('[]')[0],
                react_1.default.createElement("a", { href: 'mailto:support@open-sankey.fr\t' }, "support@open-sankey.fr"),
                t('Menu.support_explication').split('[]')[1])));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        external_modal.map((c, i) => { return react_1.default.createElement(react_1.default.Fragment, { key: i }, c); }),
        react_1.default.createElement(react_bootstrap_1.Navbar, { className: 'bg-light', fixed: 'top', style: { 'display': 'block' }, onClick: () => {
                set_contextualised_node(undefined);
                set_contextualised_link(undefined);
                set_show_context_zdd(false);
            } },
            react_1.default.createElement(react_bootstrap_1.Container, { className: 'MenuNavigation' },
                !window.SankeyToolsStatic ? react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_bootstrap_1.Navbar.Brand, { style: { marginRight: '0px' }, href: "https://terriflux.com/" },
                        react_1.default.createElement("img", { src: logo_terriflux, width: 100 }),
                        " "),
                    react_1.default.createElement("div", { style: { display: 'inline-block', width: '0px', marginLeft: '5px', marginRight: '5px', height: '40px', borderRight: 'solid 1px #ddd', borderLeft: 'solid 1px #ddd', padding: '0' } })) : react_1.default.createElement(react_1.default.Fragment, null),
                react_1.default.createElement(react_bootstrap_1.Navbar.Brand /*onClick={()=>set_welcome_text(window.sankey.welcome_text)}*/, null,
                    react_1.default.createElement("img", { src: logo, width: logo_width ? logo_width : 200 }),
                    " ",
                    window.SankeyToolsStatic ? window.sankey.header : react_1.default.createElement(react_1.default.Fragment, null),
                    " "),
                menu_nav,
                Object.keys(menus).includes('unité') ? react_1.default.createElement(react_1.default.Fragment, null, menus['unité']) : react_1.default.createElement(react_1.default.Fragment, null),
                additional_nav_item)),
        react_1.default.createElement(react_bootstrap_1.Navbar, { bg: 'light', fixed: 'bottom', style: { fontSize: '0.85em' } },
            react_1.default.createElement(react_bootstrap_1.Container, { className: 'sankeyFooter' },
                react_1.default.createElement("span", { style: { display: 'inline' } },
                    "\u00A9",
                    react_1.default.createElement("a", { href: "https://terriflux.com/" },
                        react_1.default.createElement("img", { width: 75, src: logo_terriflux })),
                    " - ",
                    t('tdr')),
                react_1.default.createElement("span", { style: { display: 'inline' } }, app_name),
                react_1.default.createElement("span", { style: { display: 'inline' } },
                    react_1.default.createElement("a", { href: 'https://terriflux.com/mentions-legales/' }, t('legal'))),
                react_1.default.createElement("span", { style: { display: 'inline' } },
                    react_1.default.createElement("a", { href: 'mailto:support@open-sankey.fr\t' }, "support@open-sankey.fr")),
                react_1.default.createElement("span", { style: { display: 'inline' } }, "9 rue du Rocher de Lorzier, 38430 Moirans  +33 (0)6 21 83 56 76"))),
        (!(window.SankeyToolsStatic ? window.SankeyToolsStatic : false)) ? react_1.default.createElement(react_bootstrap_1.Offcanvas, Object.assign({ className: 'sankey-menu', show: show_nav, placement: 'end' /*onHide={set_show_nav(false)}*/ }, props, { style: { 'width': '540px', 'marginTop': ((_a = document.getElementsByClassName('MenuNavigation')[0]) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().y) + ((_b = document.getElementsByClassName('MenuNavigation')[0]) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().height) } }),
            react_1.default.createElement(react_bootstrap_1.Offcanvas.Body, { style: { 'padding': '0px 0px 0px 0px' } },
                react_1.default.createElement(SankeyMenuConfiguration_1.SankeyConfigurationMenu, { nav_item_active: nav_item_active, accordion_ref: accordion_ref, configuration_menus: configurations_menus })))
            : react_1.default.createElement(react_1.default.Fragment, null),
        react_1.default.createElement(react_bootstrap_1.ButtonGroup, { vertical: true, className: 'sideBar', style: { top: window.innerHeight / 2 - 120, left: window.innerWidth - 40 - ((show_nav) ? 540 + has_scrollbar_shift : has_scrollbar_shift) } },
            menus['toolbar'],
            !(window.SankeyToolsStatic ? window.SankeyToolsStatic : false) ? (react_1.default.createElement(react_bootstrap_1.ToggleButton, { ref: button_ref, id: "toggle-check", className: 'openMenu', type: "checkbox", variant: "outline-primary", checked: show_nav, onChange: (e) => { setChecked(e.currentTarget.checked); }, onClick: toggleShow, value: "menuConfigButton" }, menuButton())) : (react_1.default.createElement(react_1.default.Fragment, null))),
        processing ? (react_1.default.createElement(react_bootstrap_1.Modal.Dialog, null,
            react_1.default.createElement(react_bootstrap_1.Button, { className: "btn btn-sm btn-warning col-md-12" },
                react_1.default.createElement("span", { className: "glyphicon glyphicon-refresh glyphicon-refresh-animate" }),
                " Processing..."))) : (react_1.default.createElement(react_1.default.Fragment, null)),
        react_1.default.createElement(SankeyMenuDialogs_1.ApplySaveJSONDialog, { t: t, show_save_json: show_save_json, set_show_save_json: set_show_save_json, sankey_data: data, set_sankey_data: set_data }),
        react_1.default.createElement(SankeyMenuDialogs_1.ApplyLayoutDialog, { t: t, show_apply_layout: show_apply_layout, set_show_apply_layout: set_show_apply_layout, sankey_data: data, set_sankey_data: set_data, updateLayout: updateLayout, convert_data: convert_data, node_hspace: node_hspace, set_node_hspace: set_node_hspace, node_vspace: node_vspace, set_node_vspace: set_node_vspace, data: data, set_data: set_data }),
        react_1.default.createElement(SankeyMenuDialogs_1.ExcelModal, { t: t, launch: launch, handleCloseDialog: () => set_show_excel_dialog(false), uploadExcelImpl: SankeyUtils.uploadExcelImpl, set_data: set_data, data: data, show_excel_dialog: show_excel_dialog, set_show_excel_dialog: set_show_excel_dialog, url_prefix: url_prefix, callback: callback }),
        react_1.default.createElement(SankeyLoad_1.default, { url_prefix: url_prefix, successAction: () => SankeyUtils.downloadExamples(path, url_prefix, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'), show_dialog: show_load, set_show_dialog: set_show_load, processing: processing, setProcessing: setProcessing, failure: failure, setFailure: setFailure, setNotStarted: setNotStarted, result: result, setResult: setResult }),
        // {modalTemplate}
        react_1.default.createElement(react_bootstrap_1.Modal, { size: 'xl', show: show_modalTemplate, onHide: () => set_show_modalTemplate(false) },
            react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true }, t('Banner.sdr')),
            react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
                react_1.default.createElement(react_bootstrap_1.Row, { md: 4 }, cardsTemplate))),
        modal_tuto,
        modal_support));
};
Menu.propTypes = MenuPropTypes;
exports.default = Menu;
// export //Modal for shortcut
// const OpenSankeyModalShortcut = (t:TFunction,
//   showShortcut:boolean,
//   setshowShortcut:React.Dispatch<React.SetStateAction<boolean>>,
//   additional_shortcut_item:JSX.Element[]
// )=>{
//   return <Modal size={'lg'} show={showShortcut} onHide={() => setshowShortcut(false)}>
//     <Modal.Header closeButton>
//       <Modal.Title>{t('Menu.rc')}</Modal.Title>
//     </Modal.Header>
//     <Modal.Body >
//       <h4 style={{textAlign:'center'}}>{t('Menu.rcc_titre_princ')}</h4>
//       <h5>{t('Menu.rcc_titre_select')}:</h5>
//       <p>{t('Menu.rcc_cn')}</p>
//       <p>{t('Menu.rcc_ctrl_')}</p>
//       <p><b>Click (flux) :</b> Sélectionne le flux cliqué</p>
//       <p><b>CTRL + Click (flux) :</b> Sélectionne le flux cliqué et ouvre l'onglet "<b>Flux</b>" du menu</p>
//       <p><b>Click (en dehors d'un noeud/flux) :</b>  Désélectionne les noeuds et flux sélectionnés</p>
//       <p><b>Click droit (noeuds) :</b>  Agrége le noeud</p>
//       <p><b>Alt Click droit (noeuds) :</b>  Désagrége le noeud</p>
//       <p><b>Alt + Drag (label noeuds) :</b>  Déplace le label</p>
//       <p><b>Shift + survole (noeuds) :</b>  Affiche la valeur des flux entrant et sortant du noeud dans une tooltip</p>
//       <p><b>Shift + survole (flux) :</b>  Affiche la valeur du flux dans une tooltip </p>
//       <hr style={{ borderStyle: 'none', margin: '10px', color: 'grey', backgroundColor: 'grey', height: 2 }} />
//       <h5>Avec la souris en mode édition :</h5>
//       <p><b>Click (zone de dessin) :</b> Ajoute un noeud à l'endroit cliqué</p>
//       <p><b>Drag (à partir de la zone de dessin) :</b> Crée un noeud au point de départ du drag puis crée un flux partir du noeud crée vers : soit un noeud déjà existant si l'on drop dessus, soit crée un noeud si l'on drop sur la zone de dessin </p>
//       <p><b>Drag (à partir d'un noeud) :</b> Créer un flux partir du  noeud de départ du drag vers : soit un noeud déjà existant si l'on drop dessus, soit crée un noeud si l'on drop sur la zone de dessin  </p>
//       <hr style={{ borderStyle: 'none', margin: '10px', color: 'grey', backgroundColor: 'grey', height: 2 }} />
//       <h5>Autres raccourcis :</h5>
//       <p><b>Suppr :</b> Supprime les noeuds et flux sélectionnés</p>
//       <p><b>Flèche du clavier :</b> Permet de déplacer les noeuds sélectionnés en fonction du grillage  </p>
//       <p><b>Drag (bouton du milieu de la souris et en dehors d'un noeud/flux)</b> Permet de déplacer le sankey complet  </p>
//       <p><b>Echap :</b> Ferme le Menu si il est ouvert et remet la fonction de la souris en tant que sélecteur </p>
//       {additional_shortcut_item}
//     </Modal.Body>
//     <Modal.Footer>
//       <Button variant="secondary" onClick={() => setshowShortcut(false)}>
//         Close
//       </Button>
//     </Modal.Footer>
//   </Modal>
// }
const OpenSankeyModalWelcome = (t, active_page, set_active_page, show_modal_welcome, set_show_modal_welcome, never_see_again, set_never_see_again, additional_shortcut_item, external_pagination, external_content, exemple_menu) => {
    const content_rc_static = react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("h4", { style: { textAlign: 'center' } }, t('Menu.rcc_titre_princ')),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, t('Menu.rcc_cdn_bold')),
            t('Menu.rcc_cdn')),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, t('Menu.rcc_acdn_bold')),
            t('Menu.rcc_acdn')),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, t('Menu.rcc_ctrl_scrll_bold')),
            t('Menu.rcc_ctrl_scrll')),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, t('Menu.rcc_F7_bold')),
            t('Menu.rcc_F7')),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, t('Menu.rcc_F8_bold')),
            t('Menu.rcc_F8')),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, t('Menu.rcc_F9_bold')),
            t('Menu.rcc_F9')));
    const content_rc_not_static = react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("h4", { style: { textAlign: 'center' } }, t('Menu.rcc_titre_princ')),
        react_1.default.createElement("h5", null,
            t('Menu.rcc_titre_select'),
            ":"),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, t('Menu.rcc_cn_bold')),
            t('Menu.rcc_cn')),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, t('Menu.rcc_ctrl_cn_bold')),
            t('Menu.rcc_ctrl_cn')),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, t('Menu.rcc_cf_bold')),
            t('Menu.rcc_cf')),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, t('Menu.rcc_ctrl_cf_bold')),
            t('Menu.rcc_ctrl_cf')),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, t('Menu.rcc_cs_bold')),
            t('Menu.rcc_cs')),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, t('Menu.rcc_cdn_bold')),
            t('Menu.rcc_cdn')),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, t('Menu.rcc_acdn_bold')),
            t('Menu.rcc_acdn')),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, t('Menu.rcc_ad_bold')),
            t('Menu.rcc_ad')),
        react_1.default.createElement("hr", { style: { borderStyle: 'none', margin: '10px', color: 'grey', backgroundColor: 'grey', height: 2 } }),
        react_1.default.createElement("h5", null,
            t('Menu.rcc_titre_edi'),
            " :"),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, t('Menu.rcc_e_cn_bold')),
            t('Menu.rcc_e_cn')),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, t('Menu.rcc_e_ds_bold')),
            t('Menu.rcc_e_ds')),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, t('Menu.rcc_e_dn_bold')),
            t('Menu.rcc_e_dn')),
        react_1.default.createElement("hr", { style: { borderStyle: 'none', margin: '10px', color: 'grey', backgroundColor: 'grey', height: 2 } }),
        react_1.default.createElement("h5", null,
            t('Menu.rcc_titre_autre'),
            " :"),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, t('Menu.rcc_a_s_bold')),
            t('Menu.rcc_a_s')),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, t('Menu.rcc_a_fc_bold')),
            t('Menu.rcc_a_fc')),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, t('Menu.rcc_a_dbm_bold')),
            t('Menu.rcc_a_dbm')),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, t('Menu.rcc_a_ech_bold')),
            t('Menu.rcc_a_ech')),
        react_1.default.createElement("p", null,
            react_1.default.createElement("b", null, t('Menu.rcc_ctrl_scrll_bold')),
            t('Menu.rcc_ctrl_scrll')),
        react_1.default.createElement("hr", { style: { borderStyle: 'none', margin: '10px', color: 'grey', backgroundColor: 'grey', height: 2 } }),
        additional_shortcut_item);
    external_content['rc'] = window.SankeyToolsStatic ? content_rc_static : content_rc_not_static;
    const tmp = JSON.parse(JSON.stringify(exemple_menu));
    let list_template_data = [];
    // Si exemple_menu contient OpenSankey et que ce sous dossier contient les templates simple alors remple la liste des templates avec les modèle simples
    if (Object.keys(tmp).length !== 0 && Object.keys(tmp).includes('OpenSankey') && Object.keys(tmp['OpenSankey']).includes('easy_template')) {
        list_template_data = tmp['OpenSankey']['easy_template'].filter((f) => !f.includes('.xlsx'));
        // Si l'un des sous dossier d'OpenSankey dans exemple_menu est expert_template alors ajoute les modèles expert à la liste des modèles
        if (Object.keys(tmp['OpenSankey']).includes('expert_template')) {
            list_template_data.push(tmp['OpenSankey']['expert_template']);
            list_template_data = list_template_data.flat();
        }
    }
    // external_content['licence']=content_licence
    return react_1.default.createElement(react_bootstrap_1.Modal, { scrollable: true, size: 'xl', show: show_modal_welcome && !never_see_again, onHide: () => {
            set_show_modal_welcome(false);
        } },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null, t('welcome.' + active_page))),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null, external_content[active_page]),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, { style: { justifyContent: 'center' } },
            react_1.default.createElement(react_bootstrap_1.Pagination, null,
                external_pagination.map((c, i) => { return react_1.default.createElement(react_1.default.Fragment, { key: i }, c); }),
                react_1.default.createElement(react_bootstrap_1.Pagination.Item, { active: active_page === 'rc', key: 'rc', onClick: () => {
                        set_active_page('rc');
                    } }, t('welcome.rc'))),
            react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', label: t('dontSeeAgain'), checked: never_see_again, onChange: evt => {
                    set_never_see_again(evt.target.checked);
                    localStorage.setItem('dontSeeAggainWelcome', '1');
                } })));
};
exports.OpenSankeyModalWelcome = OpenSankeyModalWelcome;
const style_menu_draggable = { 'display': 'flex', width: '25%', 'paddingLeft': '0.75rem', 'paddingRight': '0.75rem',
    'position': 'fixed',
    'flexDirection': 'column',
    'backgroundColor': '#fff',
    'backgroundClip': 'padding-box',
    'border': '1px solid rgba(0, 0, 0, 0.2)',
    'borderRadius': ' 0.6rem',
    'zIndex': '1031',
    overflowY: 'auto'
};
const menu_draggable = (content, pointer_pos, title, set_display_menu, width_menu = 25) => {
    const class_name = title.replaceAll('/', '').replaceAll('.', '').split(' ').join('_');
    const n_style_menu_draggable = JSON.parse(JSON.stringify(style_menu_draggable));
    n_style_menu_draggable.width = width_menu + '%';
    return react_1.default.createElement(react_draggable_1.default, { handle: '.title_menu', defaultPosition: { x: pointer_pos.current[0], y: pointer_pos.current[1] }, bounds: { left: 0, top: 0 }, onStart: () => {
            d3.selectAll('.menu_conf').style('z-index', '1');
            d3.select('.menu_conf.' + class_name).style('z-index', '1031');
        } },
        react_1.default.createElement("div", { className: 'menu_conf ' + class_name, style: n_style_menu_draggable },
            react_1.default.createElement(react_bootstrap_1.Row, { className: 'title_menu', style: { 'borderBottom': ' 1px solid #eceeef', 'lineHeight': '1.5rem', 'zIndex': '1', 'backgroundColor': 'white', 'position': 'sticky', 'top': '0', 'padding': '1rem' } },
                react_1.default.createElement(react_bootstrap_1.Col, null,
                    react_1.default.createElement("h3", null, title)),
                react_1.default.createElement(react_bootstrap_1.Col, { className: 'text-end' }, react_1.default.createElement(CloseButton_1.default, { onClick: () => { set_display_menu(false); } }))),
            content));
};
exports.menu_draggable = menu_draggable;
const icon_open_modal = react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { style: { float: 'right' }, icon: free_solid_svg_icons_1.faUpRightFromSquare });
const sep = react_1.default.createElement(react_bootstrap_1.Button, { variant: 'light', disabled: true },
    react_1.default.createElement("hr", { style: { borderStyle: 'none', margin: '0px', color: 'grey', backgroundColor: 'grey', height: 2 } }));
const checked = (b) => react_1.default.createElement("span", { style: { float: 'right' } }, b ? '✓' : '');
const context_menu_node = (contextualised_node, set_contextualised_node, data, set_data, multi_selected_nodes, multi_selected_links, t, set_show_menu_node_apparence, set_show_menu_node_label, set_show_menu_node_io, set_agregation_node, set_is_agregation, set_show_agregation, set_display_link_opacity, pointer_pos, additional_context_element) => {
    let style_c_n = '0px 0px auto auto';
    if (contextualised_node !== undefined) {
        style_c_n = (pointer_pos.current[1] - 20) + 'px auto auto ' + (pointer_pos.current[0] + 10) + 'px';
    }
    const align_node = (ref, attr) => {
        var _a, _b;
        const node_ref = multi_selected_nodes.current.filter(nf => nf.position != 'relative').sort((n1, n2) => {
            return ref == 'min' ? n1[attr] - n2[attr] : n2[attr] - n1[attr];
        })[0];
        const pos_ref = node_ref[attr];
        const wORh = (attr == 'x') ? 'width' : 'height';
        const wORh_ref = ((_b = (_a = document.getElementById(node_ref.idNode)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()[wORh]) !== null && _b !== void 0 ? _b : 0);
        const center_ref = pos_ref + (wORh_ref / 2);
        multi_selected_nodes.current.filter(n => n != node_ref && n.position != 'relative').forEach(n => {
            var _a, _b;
            const wORh_to_shift = ((_b = (_a = document.getElementById(n.idNode)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()[wORh]) !== null && _b !== void 0 ? _b : 0);
            n[attr] = center_ref - ((wORh_to_shift) / 2);
        });
    };
    // Dropdown to change some pararmeter concerning the appearence of the node  
    const has_node_tags = Object.values(data.nodeTags).filter(nt => nt.group_name !== 'Type de noeud').length > 0;
    const dropdown_c_n_tag = (contextualised_node !== undefined && has_node_tags) ? react_1.default.createElement(react_bootstrap_1.Dropdown, { as: react_bootstrap_1.ButtonGroup, variant: 'light', autoClose: 'outside', drop: 'end' },
        react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "light", id: "dropdown-basic" }, t('Menu.tagNode_assign')),
        react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, { variant: 'light' }, Object.entries(data.nodeTags).filter(nt => Object.keys(nt[1].tags).length > 0).map(nt => {
            return react_1.default.createElement(react_bootstrap_1.Dropdown, { autoClose: 'outside', drop: 'end' },
                react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "light", id: "dropdown-basic" }, nt[1].group_name),
                react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, { variant: 'light' }, Object.keys(nt[1].tags).map(t => {
                    return react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { as: react_bootstrap_1.Button, variant: 'light', onClick: () => {
                            // Contextualised node
                            if (!Object.keys(contextualised_node.tags).includes(nt[0])) {
                                contextualised_node.tags[nt[0]] = [];
                            }
                            if (!contextualised_node.tags[nt[0]].includes(t)) {
                                contextualised_node.tags[nt[0]].push(t);
                            }
                            else {
                                contextualised_node.tags[nt[0]].splice(contextualised_node.tags[nt[0]].indexOf(t));
                            }
                            //Selected nodes
                            multi_selected_nodes.current.filter(n => n != contextualised_node).forEach(n => {
                                if (!Object.keys(n.tags).includes(nt[0])) {
                                    n.tags[nt[0]] = [];
                                }
                                if (!n.tags[nt[0]].includes(t)) {
                                    n.tags[nt[0]].push(t);
                                }
                                else {
                                    n.tags[nt[0]].splice(n.tags[nt[0]].indexOf(t));
                                }
                            });
                            set_data(Object.assign({}, data));
                        } },
                        nt[1].tags[t].name,
                        checked(contextualised_node.tags[nt[0]] && contextualised_node.tags[nt[0]].includes(t)));
                })));
        }))) : react_1.default.createElement(react_1.default.Fragment, null);
    const dropdown_c_n_label = contextualised_node !== undefined ? react_1.default.createElement(react_bootstrap_1.Button, { onClick: () => {
            set_show_menu_node_label(true);
            set_contextualised_node(undefined);
        }, variant: 'light' },
        t('Noeud.labels.labels'),
        " ",
        icon_open_modal) : react_1.default.createElement(react_1.default.Fragment, null);
    const dropdown_c_n_apparence = contextualised_node !== undefined ? react_1.default.createElement(react_bootstrap_1.Button, { onClick: () => {
            set_show_menu_node_apparence(true);
            set_contextualised_node(undefined);
        }, variant: 'light' },
        t('Noeud.apparence.apparence'),
        " ",
        icon_open_modal) : react_1.default.createElement(react_1.default.Fragment, null);
    // Dropdown to change some pararmeter concerning the style of the node  
    const dropdown_c_n_style_select = contextualised_node !== undefined ? react_1.default.createElement(react_bootstrap_1.Dropdown, { autoClose: 'outside', as: react_bootstrap_1.ButtonGroup, variant: 'light', drop: 'end' },
        react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "light", id: "dropdown-basic" }, t('Noeud.SelectStyle')),
        react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, { variant: 'light' }, Object.values(data.style_node).map(sn => {
            return react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => {
                    contextualised_node.style = sn.idNode;
                    multi_selected_nodes.current.filter(n => n != contextualised_node).forEach(n => n.style = sn.idNode);
                    set_data(Object.assign({}, data));
                } },
                sn.name,
                checked(contextualised_node.style == sn.idNode));
        }))) : react_1.default.createElement(react_1.default.Fragment, null);
    const dropdown_c_n_style = contextualised_node !== undefined ? react_1.default.createElement(react_bootstrap_1.Dropdown, { autoClose: 'outside', as: react_bootstrap_1.ButtonGroup, variant: 'light', drop: 'end' },
        react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "light", id: "dropdown-basic" }, t('Noeud.Style')),
        react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, { variant: 'light' },
            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { as: react_bootstrap_1.Button, variant: 'light', onClick: () => {
                    delete contextualised_node.local;
                    multi_selected_nodes.current.filter(n => n != contextualised_node).forEach(n => delete n.local);
                    set_data(Object.assign({}, data));
                } }, t('Noeud.AS')),
            dropdown_c_n_style_select)) : react_1.default.createElement(react_1.default.Fragment, null);
    const dropdown_c_n_io = contextualised_node !== undefined ? react_1.default.createElement(react_bootstrap_1.Button, { onClick: () => {
            set_show_menu_node_io(true);
            set_contextualised_node(undefined);
        }, variant: 'light' },
        t('Noeud.PF.PFM'),
        icon_open_modal) : react_1.default.createElement(react_1.default.Fragment, null);
    const dropdown_c_n_align_h = contextualised_node !== undefined ? react_1.default.createElement(react_bootstrap_1.Dropdown, { autoClose: 'outside', as: react_bootstrap_1.ButtonGroup, variant: 'light', drop: 'end' },
        react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "light", id: "dropdown-basic" }, t('Noeud.align_horiz')),
        react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, { variant: 'light' },
            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => {
                    align_node('min', 'x');
                    set_data(Object.assign({}, data));
                } }, t('Noeud.align_horiz_min')),
            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => {
                    align_node('max', 'x');
                    set_data(Object.assign({}, data));
                } }, t('Noeud.align_horiz_max')))) : react_1.default.createElement(react_1.default.Fragment, null);
    const dropdown_c_n_align_v = contextualised_node !== undefined ? react_1.default.createElement(react_bootstrap_1.Dropdown, { autoClose: 'outside', as: react_bootstrap_1.ButtonGroup, variant: 'light', drop: 'end' },
        react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "light", id: "dropdown-basic" }, t('Noeud.align_vert')),
        react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, { variant: 'light' },
            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => {
                    align_node('min', 'y');
                    set_data(Object.assign({}, data));
                } }, t('Noeud.align_vert_min')),
            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => {
                    align_node('max', 'y');
                    set_data(Object.assign({}, data));
                } }, t('Noeud.align_vert_max')))) : react_1.default.createElement(react_1.default.Fragment, null);
    // Pop over that serve as context menu 
    return contextualised_node !== undefined ? react_1.default.createElement(react_bootstrap_1.Popover, { id: "context_node_pop_over", style: { maxWidth: '100%', position: 'absolute', inset: style_c_n } },
        react_1.default.createElement(react_bootstrap_1.Popover.Body, null,
            react_1.default.createElement(react_bootstrap_1.ButtonGroup, { vertical: true },
                multi_selected_nodes.current.filter(n => n != contextualised_node).length == 0 && SankeyUtils.node_context_has_aggregate(contextualised_node, data) ? react_1.default.createElement(react_bootstrap_1.Button, { variant: 'light', onClick: () => {
                        SankeyUtils.aggregate(contextualised_node, data, set_agregation_node, set_is_agregation, set_show_agregation);
                        set_data(Object.assign({}, data));
                        set_contextualised_node(undefined);
                    } }, "Aggregation") : react_1.default.createElement(react_1.default.Fragment, null),
                multi_selected_nodes.current.filter(n => n != contextualised_node).length == 0 && SankeyUtils.node_context_has_desaggregate(contextualised_node, data) ? react_1.default.createElement(react_bootstrap_1.Button, { variant: 'light', onClick: () => {
                        SankeyUtils.desaggregate(contextualised_node, data, set_agregation_node, set_is_agregation, set_show_agregation);
                        set_data(Object.assign({}, data));
                        set_contextualised_node(undefined);
                    } }, "Desaggregation") : react_1.default.createElement(react_1.default.Fragment, null),
                sep,
                react_1.default.createElement(react_bootstrap_1.Button, { variant: 'light', onClick: () => {
                        multi_selected_links.current = [];
                        multi_selected_links.current = Object.values(data.links).filter(l => contextualised_node.outputLinksId.includes(l.idLink));
                        const opacity = SankeyUtils.return_value_link(data, multi_selected_links.current[0], 'opacity');
                        set_display_link_opacity(opacity);
                        set_contextualised_node(undefined);
                        set_data(data);
                    } }, t('Noeud.SlctOutLink')),
                react_1.default.createElement(react_bootstrap_1.Button, { variant: 'light', onClick: () => {
                        multi_selected_links.current = [];
                        multi_selected_links.current = Object.values(data.links).filter(l => contextualised_node.inputLinksId.includes(l.idLink));
                        const opacity = SankeyUtils.return_value_link(data, multi_selected_links.current[0], 'opacity');
                        set_display_link_opacity(opacity);
                        set_contextualised_node(undefined);
                        set_data(data);
                    } }, t('Noeud.SlctInLink')),
                react_1.default.createElement(react_bootstrap_1.Button, { variant: 'light', onClick: () => {
                        SankeyLayout_1.reorganize_node_inputLinksId(data, contextualised_node, data.nodes, data.links);
                        SankeyLayout_1.reorganize_node_outputLinksId(data, contextualised_node, data.nodes, data.links);
                        multi_selected_nodes.current.filter(n => n != contextualised_node).forEach(n => {
                            SankeyLayout_1.reorganize_node_inputLinksId(data, n, data.nodes, data.links);
                            SankeyLayout_1.reorganize_node_outputLinksId(data, n, data.nodes, data.links);
                        });
                        set_contextualised_node(undefined);
                        set_data(Object.assign({}, data));
                    } }, t('Noeud.Reorg')),
                multi_selected_nodes.current.length == 1 ? dropdown_c_n_io : react_1.default.createElement(react_1.default.Fragment, null),
                sep,
                dropdown_c_n_align_h,
                dropdown_c_n_align_v,
                has_node_tags ? sep : react_1.default.createElement(react_1.default.Fragment, null),
                dropdown_c_n_tag,
                sep,
                dropdown_c_n_apparence,
                dropdown_c_n_label,
                additional_context_element,
                sep,
                dropdown_c_n_style))) : react_1.default.createElement(react_1.default.Fragment, null);
};
exports.context_menu_node = context_menu_node;
const context_menu_link = (contextualised_link, set_contextualised_node, set_show_menu_link_data, set_show_menu_link_appearence, set_show_menu_link_label, data, set_data, tags_selected, multi_selected_links, t, pointer_pos) => {
    let style_c_l = '0px 0px auto auto';
    if (contextualised_link !== undefined) {
        style_c_l = (pointer_pos.current[1] - 20) + 'px auto auto ' + (pointer_pos.current[0] + 10) + 'px';
    }
    const invert_flux = (l, nodes_to_reorganize) => {
        const tmp = l.idSource;
        const previous_node_s = data.nodes[l.idSource];
        previous_node_s.outputLinksId.splice(previous_node_s.outputLinksId.indexOf(l.idLink), 1);
        const source_node = data.nodes[l.idTarget];
        l.idSource = source_node.idNode;
        source_node.outputLinksId.push(l.idLink);
        nodes_to_reorganize.push(source_node);
        const previous_node_t = data.nodes[l.idTarget];
        previous_node_t.inputLinksId.splice(previous_node_t.inputLinksId.indexOf(l.idLink), 1);
        const target_node = data.nodes[tmp];
        l.idTarget = target_node.idNode;
        target_node.inputLinksId.push(l.idLink);
        nodes_to_reorganize.push(target_node);
    };
    const value_selected_parameter_contextualised_link = () => {
        if (contextualised_link === undefined) {
            return {};
        }
        else {
            if (Object.keys(data.links).length === 0 || !(contextualised_link.idLink in data.links)) {
                let val = JSON.parse(JSON.stringify(Object(contextualised_link.value)));
                Object.values(tags_selected).map(tag_selected => {
                    if (val[tag_selected] === undefined) {
                        val[tag_selected] = {};
                    }
                    val = val[tag_selected];
                });
                return val;
            }
            let val = JSON.parse(JSON.stringify(Object(data.links[contextualised_link.idLink].value)));
            Object.values(tags_selected).map(tag_selected => {
                if (val[tag_selected] === undefined) {
                    val[tag_selected] = { 'display_value': '', tags: {}, value: 0 };
                }
                val = val[tag_selected];
            });
            return val;
        }
    };
    const has_flux_tags = Object.values(data.fluxTags).length > 0;
    // Dropdown to change some pararmeter concerning the appearence of the node  
    const dropdown_c_l_tag = (contextualised_link !== undefined && has_flux_tags) && Object.entries(data.nodeTags).length > 0 ? react_1.default.createElement(react_bootstrap_1.Dropdown, { as: react_bootstrap_1.ButtonGroup, variant: 'light', autoClose: 'outside', drop: 'end' },
        react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "light", id: "dropdown-basic" }, t('Menu.tagFlux_assign')),
        react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, { variant: 'light' }, Object.entries(data.fluxTags).filter(nt => Object.keys(nt[1].tags).length > 0).map(nt => {
            return react_1.default.createElement(react_bootstrap_1.Dropdown, { as: react_bootstrap_1.Button, variant: 'light', autoClose: 'outside', drop: 'end' },
                react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "light", id: "dropdown-basic" }, nt[1].group_name),
                react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, { variant: 'light' }, Object.keys(nt[1].tags).map(t => {
                    return react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => {
                            // Assign tag to selected links
                            multi_selected_links.current.filter(l => l !== contextualised_link).forEach(l => {
                                let val = Object(l.value);
                                Object.values(tags_selected).forEach(tag => {
                                    if (val[tag] === undefined) {
                                        val[tag] = {};
                                    }
                                    val = val[tag];
                                });
                                if (!Object.keys(val.tags).includes(nt[0])) {
                                    val.tags[nt[0]] = [];
                                }
                                if (!val.tags[nt[0]].includes(t)) {
                                    val.tags[nt[0]].push(t);
                                }
                                else {
                                    val.tags[nt[0]].splice(val.tags[nt[0]].indexOf(t));
                                }
                                //val.tags[nt[0]] = !(value_selected_parameter_contextualised_link().tags[nt[0]] === t)? t : ''
                            });
                            // Assign tag to contextualised link
                            let val = Object(contextualised_link.value);
                            Object.values(tags_selected).forEach(tag => {
                                if (val[tag] === undefined) {
                                    val[tag] = {};
                                }
                                val = val[tag];
                            });
                            if (!Object.keys(val.tags).includes(nt[0])) {
                                val.tags[nt[0]] = [];
                            }
                            if (!val.tags[nt[0]].includes(t)) {
                                val.tags[nt[0]].push(t);
                            }
                            else {
                                val.tags[nt[0]].splice(val.tags[nt[0]].indexOf(t));
                            }
                            //val.tags[nt[0]] = !(value_selected_parameter_contextualised_link().tags[nt[0]] === t)? t : ''
                            set_data(Object.assign({}, data));
                        } },
                        nt[1].tags[t].name,
                        checked(value_selected_parameter_contextualised_link().tags[nt[0]].includes(t)));
                })));
        }))) : react_1.default.createElement(react_1.default.Fragment, null);
    const button_open_link_label = contextualised_link !== undefined ? react_1.default.createElement(react_bootstrap_1.Button, { onClick: () => {
            set_show_menu_link_label(true);
            set_contextualised_node(undefined);
        }, variant: 'light' },
        t('Flux.label.label'),
        " ",
        icon_open_modal) : react_1.default.createElement(react_1.default.Fragment, null);
    const button_open_link_appearence = contextualised_link !== undefined ? react_1.default.createElement(react_bootstrap_1.Button, { onClick: () => {
            set_show_menu_link_appearence(true);
            set_contextualised_node(undefined);
        }, variant: 'light' },
        t('Flux.apparence.apparence'),
        " ",
        icon_open_modal) : react_1.default.createElement(react_1.default.Fragment, null);
    // Dropdown to change some pararmeter concerning the style of the node  
    const dropdown_c_l_style_select = contextualised_link !== undefined ? react_1.default.createElement(react_bootstrap_1.Dropdown, { autoClose: 'outside', as: react_bootstrap_1.ButtonGroup, variant: 'light', drop: 'end' },
        react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "light", id: "dropdown-basic" }, t('Noeud.SelectStyle')),
        react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, { variant: 'light' }, Object.values(data.style_node).map(sn => {
            return react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => {
                    contextualised_link.style = sn.idNode;
                    multi_selected_links.current.filter(n => n != contextualised_link).forEach(n => n.style = sn.idNode);
                    set_data(Object.assign({}, data));
                } },
                sn.name,
                checked(contextualised_link.style == sn.idNode));
        }))) : react_1.default.createElement(react_1.default.Fragment, null);
    const dropdown_c_l_style = contextualised_link !== undefined ? react_1.default.createElement(react_bootstrap_1.Dropdown, { autoClose: 'outside', as: react_bootstrap_1.ButtonGroup, variant: 'light', drop: 'end' },
        react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "light", id: "dropdown-basic" }, t('Noeud.Style')),
        react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, { variant: 'light' },
            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { as: react_bootstrap_1.Button, variant: 'light', onClick: () => {
                    delete contextualised_link.local;
                    multi_selected_links.current.filter(n => n != contextualised_link).forEach(n => delete n.local);
                    set_data(Object.assign({}, data));
                } }, t('Noeud.AS')),
            dropdown_c_l_style_select)) : react_1.default.createElement(react_1.default.Fragment, null);
    const dropdown_c_l_layout = contextualised_link !== undefined ? react_1.default.createElement(react_bootstrap_1.Dropdown, { autoClose: 'outside', as: react_bootstrap_1.ButtonGroup, variant: 'light', drop: 'end' },
        react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "light", id: "dropdown-basic" }, t('Flux.layout')),
        react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, { variant: 'light' },
            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => {
                    multi_selected_links.current.forEach(n => SankeyMenuConfigurationLinks_1.handleDownLink(data, n.idLink));
                    set_data(Object.assign({}, data));
                } }, t('Flux.layoutUp')),
            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => {
                    multi_selected_links.current.map(l => {
                        const i = l.idLink;
                        const { links } = data;
                        const listElmt = Object.keys(links);
                        const posElemt = listElmt.indexOf(i);
                        listElmt.splice(posElemt, 1);
                        listElmt.splice(listElmt.length, 0, i);
                        const new_cat = {};
                        listElmt.forEach(elt => {
                            new_cat[elt] = links[elt];
                        });
                        for (const member in links)
                            delete links[member];
                        Object.assign(links, new_cat);
                    });
                    set_data(Object.assign({}, data));
                } }, t('Flux.layoutTop')),
            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => {
                    multi_selected_links.current.forEach(n => SankeyMenuConfigurationLinks_1.handleUpLink(data, n.idLink));
                    set_data(Object.assign({}, data));
                } }, t('Flux.layoutDown')),
            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { onClick: () => {
                    multi_selected_links.current.map(l => {
                        const i = l.idLink;
                        const { links } = data;
                        const listElmt = Object.keys(links);
                        const posElemt = listElmt.indexOf(i);
                        listElmt.splice(posElemt, 1);
                        listElmt.splice(0, 0, i);
                        const new_cat = {};
                        listElmt.forEach(elt => {
                            new_cat[elt] = links[elt];
                        });
                        for (const member in links)
                            delete links[member];
                        Object.assign(links, new_cat);
                    });
                    set_data(Object.assign({}, data));
                } }, t('Flux.layoutBottom')))) : react_1.default.createElement(react_1.default.Fragment, null);
    const button_open_link_data = contextualised_link !== undefined ? react_1.default.createElement(react_bootstrap_1.Button, { onClick: () => {
            set_show_menu_link_data(true);
            set_contextualised_node(undefined);
        }, variant: 'light' },
        t('Flux.data.données'),
        " ",
        icon_open_modal) : react_1.default.createElement(react_1.default.Fragment, null);
    // Pop over that serve as context menu 
    return contextualised_link !== undefined ? react_1.default.createElement(react_bootstrap_1.Popover, { id: "context_link_pop_over", style: { maxWidth: '100%', position: 'absolute', inset: style_c_l } },
        react_1.default.createElement(react_bootstrap_1.Popover.Body, null,
            react_1.default.createElement(react_bootstrap_1.ButtonGroup, { vertical: true },
                react_1.default.createElement(react_bootstrap_1.Button, { variant: 'light', onClick: () => {
                        const nodes_to_reorganize = [];
                        invert_flux(contextualised_link, nodes_to_reorganize);
                        multi_selected_links.current.filter(l => l !== contextualised_link).forEach(l => {
                            invert_flux(l, nodes_to_reorganize);
                        });
                        nodes_to_reorganize.forEach(n => {
                            SankeyLayout_2.reorganize_inputLinksId(data, n, true, true, data.nodes, data.links);
                        });
                        set_data(Object.assign({}, data));
                    } }, t('Flux.if')),
                sep,
                dropdown_c_l_layout,
                has_flux_tags && sep,
                dropdown_c_l_tag,
                sep,
                button_open_link_data,
                button_open_link_appearence,
                button_open_link_label,
                sep,
                dropdown_c_l_style))) : react_1.default.createElement(react_1.default.Fragment, null);
};
exports.context_menu_link = context_menu_link;
const context_zdd = (show_context_zdd, set_show_context_zdd, data, set_data, pointer_pos, node_hspace, set_node_hspace, node_vspace, set_node_vspace, t, set_show_menu_layout) => {
    let style_c_zdd = '0px 0px auto auto';
    if (show_context_zdd) {
        style_c_zdd = (pointer_pos.current[1] - 20) + 'px auto auto ' + (pointer_pos.current[0] + 10) + 'px';
    }
    const button_bg_color = react_1.default.createElement(react_bootstrap_1.Form, { as: react_bootstrap_1.Button, variant: 'light' },
        react_1.default.createElement(react_bootstrap_1.Form.Control, { hidden: true, type: 'color', id: 'color_bg_zdd', name: 'color_bg_zdd', onChange: (evt) => {
                data.couleur_fond_sankey = evt.target.value;
                set_data(Object.assign({}, data));
            } }),
        react_1.default.createElement(react_bootstrap_1.Form.Label, { htmlFor: 'color_bg_zdd' }, t('Menu.BgC')));
    const button_bg_grid = react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Button, { variant: 'light', onClick: () => {
                data.grid_visible = !data.grid_visible;
                set_data(Object.assign({}, data));
            } },
            t('MEP.TCG'),
            checked(data.grid_visible)));
    const dropdown_c_zdd_scale = react_1.default.createElement(react_bootstrap_1.Dropdown, { autoClose: 'outside', as: react_bootstrap_1.ButtonGroup, variant: 'light', drop: 'end' },
        react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "light", id: "dropdown-basic" }, t('MEP.Echelle')),
        react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, { variant: 'light' },
            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { as: react_bootstrap_1.Button, variant: 'light' },
                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "text", value: data.user_scale, onChange: evt => {
                        data.user_scale = +evt.target.value;
                        set_data(Object.assign({}, data));
                    } }))));
    const dropdown_c_zdd_max_size_link = react_1.default.createElement(react_bootstrap_1.Dropdown, { autoClose: 'outside', as: react_bootstrap_1.ButtonGroup, variant: 'light', drop: 'end' },
        react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "light", id: "dropdown-basic" }, t('MEP.MaxFlux')),
        react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, { variant: 'light' },
            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { as: react_bootstrap_1.Button, variant: 'light' },
                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "text", value: data.maximum_flux == null ? undefined : data.maximum_flux, onChange: (evt) => {
                        const maximum_flux = isNaN(+evt.target.value) ? null : +evt.target.value;
                        data.maximum_flux = maximum_flux;
                        set_data(Object.assign({}, data));
                    } }))));
    const dropdown_c_zdd_min_size_link = react_1.default.createElement(react_bootstrap_1.Dropdown, { autoClose: 'outside', as: react_bootstrap_1.ButtonGroup, variant: 'light', drop: 'end' },
        react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "light", id: "dropdown-basic" }, t('MEP.MinFlux')),
        react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, { variant: 'light' },
            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { as: react_bootstrap_1.Button, variant: 'light' },
                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "text", value: data.minimum_flux == null ? undefined : data.minimum_flux, onChange: (evt) => {
                        const minimum_flux = isNaN(+evt.target.value) ? null : +evt.target.value;
                        data.minimum_flux = minimum_flux;
                        set_data(Object.assign({}, data));
                    } }))));
    const button_pa = react_1.default.createElement(react_bootstrap_1.Dropdown, { autoClose: 'outside', as: react_bootstrap_1.ButtonGroup, variant: 'light', drop: 'end' },
        react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "light", id: "dropdown-basic" }, t('MEP.PA')),
        react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, { variant: 'light' },
            react_1.default.createElement(react_bootstrap_1.Dropdown, { autoClose: 'outside', as: react_bootstrap_1.ButtonGroup, variant: 'light', drop: 'end' },
                react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "light", id: "dropdown-basic" }, t('MEP.Horizontal')),
                react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, { variant: 'light' },
                    react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { as: react_bootstrap_1.Button, variant: 'light' },
                        react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "text", value: node_hspace, onChange: evt => {
                                set_node_hspace(+evt.target.value);
                                data.h_space = +evt.target.value;
                            } })))),
            react_1.default.createElement(react_bootstrap_1.Dropdown, { autoClose: 'outside', as: react_bootstrap_1.ButtonGroup, variant: 'light', drop: 'end' },
                react_1.default.createElement(react_bootstrap_1.Dropdown.Toggle, { variant: "light", id: "dropdown-basic" }, t('MEP.Vertical')),
                react_1.default.createElement(react_bootstrap_1.Dropdown.Menu, { variant: 'light' },
                    react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { as: react_bootstrap_1.Button, variant: 'light' },
                        react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "text", value: node_vspace, onChange: evt => {
                                set_node_vspace(+evt.target.value);
                                data.h_space = +evt.target.value;
                            } })))),
            react_1.default.createElement(react_bootstrap_1.Dropdown.Item, { as: react_bootstrap_1.Button, variant: 'light', onClick: () => {
                    SankeyLayout_3.compute_auto_sankey(data, node_hspace);
                    set_data(Object.assign({}, data));
                } }, t('MEP.PA_action'))));
    const button_an = react_1.default.createElement(react_bootstrap_1.Button, { variant: 'light', onClick: () => {
            SankeyLayout_3.arrangeNodes(data);
            set_data(Object.assign({}, data));
        } }, t('MEP.AN'));
    let full = t('fullscreen');
    if (!document.fullscreenElement) {
        full = t('fullscreen');
    }
    else {
        full = t('exitFullscreen');
    }
    const button_fullscreen = react_1.default.createElement(react_bootstrap_1.Button, { variant: 'light', onClick: () => {
            if (!document.fullscreenElement) {
                document.documentElement.requestFullscreen();
            }
            else if (document.exitFullscreen) {
                document.exitFullscreen();
            }
            set_show_context_zdd(false);
        } }, full);
    const button_open_layout = react_1.default.createElement(react_bootstrap_1.Button, { onClick: () => {
            set_show_menu_layout(true);
            set_show_context_zdd(false);
        }, variant: 'light' },
        t('Menu.MEP'),
        " ",
        icon_open_modal);
    return show_context_zdd ? react_1.default.createElement(react_bootstrap_1.Popover, { id: "context_zdd_pop_over", style: { maxWidth: '100%', position: 'absolute', inset: style_c_zdd } },
        react_1.default.createElement(react_bootstrap_1.Popover.Body, null,
            react_1.default.createElement(react_bootstrap_1.ButtonGroup, { vertical: true },
                button_fullscreen,
                sep,
                button_open_layout,
                sep,
                button_bg_color,
                button_bg_grid,
                dropdown_c_zdd_scale,
                dropdown_c_zdd_min_size_link,
                dropdown_c_zdd_max_size_link,
                sep,
                button_pa,
                button_an))) : react_1.default.createElement(react_1.default.Fragment, null);
};
exports.context_zdd = context_zdd;
